import axios from '@/util/axios';

import { getCache } from 'core/cache';
import { getSelectOptions } from '@/exceed';
import { handleAxiosError } from 'core/notifications';
import i18n from 'i18next';

export default async (input) => {
  const { id } = getCache('initiative').data;
  const url = `/api/admin/initiatives/${id}/untagged_content`;
  let content;

  try {
    ({ data: { data: content } } = await axios.get(url, {
      params: { search_query: input },
    }));
  } catch (error) {
    return handleAxiosError(error);
  }

  const options = getSelectOptions(content);

  return input ? options : [{ label: i18n.t('suggested-content'), options }];
};
